import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoginComponent } from './auth-layout/login/login.component';
import { OtpVerificationComponent } from './auth-layout/otp-verification/otp-verification.component';
import { SingupComponent } from './auth-layout/singup/singup.component';
import { CmsLayoutComponent } from './cms-layout/cms-layout.component';
import { P401ErrorComponent } from './errors/401.component';
import { P404ErrorComponent } from './errors/404.component';
import { P419ErrorComponent } from './errors/419.component';
import { P500ErrorComponent } from './errors/500.component';
import { GuestGuard } from './guards/guest.guard';
import { UserGuard } from './guards/user.guard';
import { MainLayoutComponent } from './main-layout/main-layout.component';
import { SellerOnboardComponent } from './auth-layout/seller-onboard/seller-onboard.component';

const routes: Routes = [
    { path: 'login', redirectTo: 'buyer/login', pathMatch: 'full' },
    { path: ':role/login', component: LoginComponent, data: { pageTitle: 'Login' }, canActivate: [GuestGuard] },
    { path: 'seller/onboard', component: SellerOnboardComponent, data: { pageTitle: 'Seller Onboard' }, canActivate: [GuestGuard] },

    { path: 'register', component: SingupComponent, data: { pageTitle: 'Register' }, canActivate: [GuestGuard] },
    { path: 'otp-verification/user-register/:token', component: OtpVerificationComponent, data: { pageTitle: 'Complete Registration', otpData: { type: 'user-register' } }, canActivate: [GuestGuard] },
    { path: 'otp-verification/seller-register/:token', component: OtpVerificationComponent, data: { pageTitle: 'Complete Registration', otpData: { type: 'seller-register' } }, canActivate: [GuestGuard] },

    { path: 'otp-verification/user-login/:token', component: OtpVerificationComponent, data: { pageTitle: 'Complete SignIn', otpData: { type: 'user-login' } }, canActivate: [GuestGuard] },
    { path: 'otp-verification/user-resetpassword/:token', component: OtpVerificationComponent, data: { pageTitle: 'Complete Password Reset', otpData: { type: 'user-resetpassword' } }, canActivate: [GuestGuard] },

    {
        path: '',
        component: CmsLayoutComponent,
        loadChildren: () =>
            import('./cms-layout/cms-layout.module').then((m) => m.CmsLayoutModule),
    },
    {
        path: 'dashboard',
        component: MainLayoutComponent,
        canActivate: [UserGuard],
        loadChildren: () =>
            import('./main-layout/main-layout.module').then((m) => m.MainLayoutModule),
    },

    { path: 'error/401', component: P401ErrorComponent, data: { pageTitle: 'Unauthorized' } },
    { path: 'error/419', component: P419ErrorComponent, data: { pageTitle: 'Page Expired' } },
    { path: 'error/500', component: P500ErrorComponent, data: { pageTitle: 'Server Error' } },
    { path: 'error/404', component: P404ErrorComponent, data: { pageTitle: 'Not Found' } },
    { path: '**', component: P404ErrorComponent, data: { pageTitle: 'Not Found' } }
];

@NgModule({
    imports: [RouterModule.forRoot(routes,
        {
            anchorScrolling: 'enabled',
            onSameUrlNavigation: 'reload',
            scrollPositionRestoration: 'enabled',
            scrollOffset: [0, 0],
        })],
    exports: [RouterModule]
})
export class AppRoutingModule { }
